import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconV2, Link } from '@express-labs/raven-ui';

import s from './CustomerStore.module.scss';
import ChangeStore from './ChangeStore/ChangeStore';
import { analyze } from '../../../../helpers';

const CHAR_LIMIT = 11;

function CustomerStore({ isMobile, customerStore }) {
  let { name = 'Change Store' } = customerStore;

  const [isChangeStoreOpen, setIsChangeStoreOpen] = useState(false);
  const toggleChangeStoreModal = () => setIsChangeStoreOpen(!isChangeStoreOpen);

  if (!isMobile && name?.length > CHAR_LIMIT) {
    name = `${name?.substring(0, CHAR_LIMIT)}...`;
  }

  const onChangeStore = () => {
    toggleChangeStoreModal();
    analyze({
      name: 'changeStoreFromHeader',
      data: {
        url: window?.location?.href,
      },
      props: {},
    });
  };

  return (
    <div className={s.storeContainer}>
      {isMobile && <strong className={s.storeContainerTitle}>Your Store</strong>}
      <IconV2 icon="store" size="small" />
      <Link
        id="store-container-link"
        as="button"
        theme="dark"
        size="body"
        onClick={onChangeStore}

      >
        {name}
      </Link>
      {isChangeStoreOpen
        && (
        <ChangeStore
          onModalClose={toggleChangeStoreModal}
        />
        )}
    </div>
  );
}

CustomerStore.propTypes = {
  isMobile: PropTypes.bool,
  customerStore: PropTypes.shape({
    name: PropTypes.string,
  }),
};

CustomerStore.defaultProps = {
  isMobile: false,
  customerStore: {},
};

export default CustomerStore;
